import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SearchComponentService } from '../../shared';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { MODE } from '../../shared/constant';

// Search Component
@Component({
  selector: 'search-component',
  styleUrls: ['./../question.scss'],
  template: `<div
    [class.has-error]="(isSubmitClicked && !control?.valid) || (control?.errors?.Required && mode != readOnly)"
    [ngClass]="{'col-md-4 inline-padding': questiondata.params.inline == 3,'col-md-3 inline-padding': questiondata.params.inline == 4}"
    [ngClass]="{'col-md-3 inline-padding': questiondata.params.inline == 4}" [attr.id]="sectionId+'_'+questiondata.order+'_div'">
                   <label-text
                     [questiondata]="questiondata"
                     [helptext]="questiondata.helpText"
                     [attrFor]="sectionId+'_'+questiondata.order"></label-text>
                     <div [ngClass]="{'show-list' : !questiondata.params.inline}">
                         <table>
                            <tr *ngFor="let item of selected">
                              <td [class.fixed-width]='mode != readOnly'>{{item.display}}</td>
                              <td><a (click)="remove(item)" *ngIf="mode != readOnly" class="item-link"><i class="glyphicon glyphicon-remove"></i></a></td>
                            </tr>
                          <ng-container *ngIf="!selected">
                            <tr *ngFor="let iteration of questiondata.iterations">
                              <td *ngIf="mode == 'readOnly' && iteration.responseText" [class.fixed-width]='mode == readOnly'>
                                {{iteration.responseMetadata.chosenResponses[0].display}}
                              </td>
                            </tr>
                          </ng-container>
                         </table>
                      </div>

                       <div [ngClass]="{'search' : !questiondata.params.inline}" *ngIf= "!disableButton">
                        <input class="form-control"
                              [(ngModel)]="selectedName"
                              [typeahead]="dataSource"
                              (typeaheadNoResults)="changeTypeaheadNoResults($event)"
                              (typeaheadOnSelect)="typeaheadOnSelect($event)"
                              [typeaheadOptionsLimit]="10"
                              [typeaheadOptionField]="'display'"
                              [typeaheadWaitMs]='300'
                              [typeaheadMinLength]="2"
                              placeholder="{{placeHolder}}"
                              *ngIf= "!disableButton"
                              [disabled]="mode == 'readOnly'"
                              [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' " [attr.id]="sectionId+'_'+questiondata.order" >
                          <a (click)="clearInput()" *ngIf="mode != readOnly && !!selectedName && !disableButton" class="input-clear"><i class="glyphicon glyphicon-remove"></i></a>
                       </div>
                       <div *ngIf="typeaheadNoResults || duplicateResult" class="validation-text">
                        <span *ngIf="typeaheadNoResults" [innerHTML]="typeaheadNoResultsText"></span>
                        <span *ngIf="duplicateResult"> Duplicate entries. </span>
                       </div>
                      <errorMessages *ngIf="mode != readOnly && !typeaheadNoResults" [control]='control' [params]='questiondata.params' [isSubmitClicked]="isSubmitClicked"></errorMessages>
                      <span *ngIf="errorMessage.status==0 && mode != readOnly && !typeaheadNoResults " class="text-danger">No search results found</span>                      <br/>
                  </div> <br *ngIf="!questiondata.params.inline" />
                   `,
})

export class SearchComponent {
  @Input() questiondata: any;
  @Input() form: any;
  @Input() control: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked;
  @Input() controlObject: any;
  @Input() mode: string;
  @Input() campusCode: string;
  @Input() env: any;


  searchResults: Array<any> = [];
  dataSource: Observable<any>;
  selectedName = '';
  searchApi = '';
  selected = null;
  selectedValues = [];
  typeaheadNoResults = false;
  disableButton = false;
  duplicateResult = false;
  maxIterations = 1;
  readOnly = MODE.READONLY;
  errorMessage: any = {};
  searchSubscription: Subscription;
  private response = [];
  private defaultPlaceHolder = 'Search';
  private placeHolder = '';
  private typeaheadNoResultsText = 'No results found.';

  constructor(private _searchComponentService: SearchComponentService, private fb: FormBuilder) {
    this.dataSource = Observable.create((observer: any) => {
      observer.next(this.selectedName);
    }).mergeMap((token: string) => this.getSearchNameAsObservable(token));
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changes: any) {
    if (changes.mode) {
      this.init();
    }
  }

  init() {
    (this.mode === MODE.READONLY) ? this.control.disable(true) : this.control.enable(true);
    this.placeHolder = (this.questiondata.params.placeHolder ? this.questiondata.params.placeHolder : this.defaultPlaceHolder);
    this.maxIterations = this.questiondata.params.maxIterations ? this.questiondata.params.maxIterations : 1;
    if (this.mode !== MODE.READONLY) {
      if (this.selected == null) {


        this.selected = [];
        if (this.questiondata.iterations) {
          this.questiondata.iterations.forEach(iteration => {
            if (iteration.responseText) {
              // if (!this.selected.length) {
              this.selected.push(iteration.responseMetadata.chosenResponses[0]);
              this.selectedValues.push(iteration.responseMetadata.chosenResponses[0].value);
              this.buildResponseMetadata();
              // }
            }
          });
        }
        this.disableButton = !(this.selected.length < this.questiondata.params.maxIterations || this.selected.length < 1);
      }
    }

  }

  typeaheadOnSelect(e): void {
    if (this.selectedValues.indexOf(e['item'].value) === -1) {
      if (this.selected.length < this.maxIterations) {
        this.selected.push(e['item']);
        this.selectedValues.push(e['item'].value);
        this.duplicateResult = false;
        this.selected.length === this.maxIterations ? this.disableButton = true : this.duplicateResult = false;
        try {
          this._searchComponentService.upsertPerson(this.selected[this.selected.length - 1]);
        } catch (error) {
          console.error('Error calling get person details', error);
        }
      } else {
        this.disableButton = true;
      }
      this.response.push(this.selected[this.selected.length - 1].value);
      this.selectedName = '';
    } else {
      this.selectedName = '';
      this.duplicateResult = true;
    }
    this.selected.length === 0 ? this.control.setValue('') : this.control.setValue(this.response[0]);
    this.buildResponseMetadata();
    this.errorMessage = {};
  }

  buildResponseMetadata() {
    let iterations = [];
    if (this.selected.length > 0) {
      this.selected.forEach((elem, index) => {
        iterations.push({
          iteration: index + 1,
          response: elem.value,
          responseMetadata: {
            allowedResponses: [],
            chosenResponses: [elem],
          },
        });
      });
    } else {
      iterations.push({
        iteration: 1,
        response: '',
        responseMetadata: null,
      });
    }
    this.selected.length === 0 ? this.control.setValue('') : this.control.setValue(iterations[0].response);
    this.controlObject.value.iterations = iterations;
  }

  remove(item) {
    this.selected.splice(this.selected.indexOf(item), 1);
    this.selectedValues.splice(this.selectedValues.indexOf(item.value), 1);
    this.disableButton = false;
    this.selected.length === 0 ? this.control.setValue('') : this.control.setValue(this.selected[0]);
    this.buildResponseMetadata();
    this.duplicateResult = false;
  }

  getSearchNameAsObservable(token: string): Observable<any> {
    this.searchApi = this.questiondata.params.searchApi;

    if (/person/.test(this.searchApi)) {
      this.typeaheadNoResultsText = `<span>
      The employee is not currently listed within the campus <strong>'person'</strong> directory information that was provided to us.
      </span>
      <span>Ask the employee to log into the following URL with their campus credentials:
      <strong><a href="https://app.riskandsafety.com" target="_blank">https://app.riskandsafety.com</a></strong>.</span>
      <span>Once they confirm they have successfully logged in, try to add the employee again searching by name or email address.</span>
      `;
    }

    return Observable.create((observer: any) => {
      if (token.length >= 2) {
        this._searchComponentService.getSearchNames(this.selectedValues, this.searchApi, token, this.campusCode).then((data: any) => {
          observer.next(data);
        }).catch(error => {
          this.errorMessage = error;
          this.control.setErrors(null);
        });
      }
    });
  }

  changeTypeaheadNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }

  clearInput() {
    this.selectedName = '';
    this.duplicateResult = false;
    this.typeaheadNoResults = false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/controls/search.component.ts